import { Component, OnDestroy, OnInit } from '@angular/core';
import { 
  NbMenuService, 
  NbThemeService 
} from '@nebular/theme';
import { Store, select } from '@ngrx/store';
import { Subject, Observable, Subscription } from 'rxjs';
import {TranslateService} from '@ngx-translate/core';
import { CompanyState } from '@app/@core/store/reducers/company.reducers';
import { loadCompany } from '@app/@core/store/actions/company.actions';
import { ActivatedRoute, Router } from '@angular/router';
import { Company } from '@app/@core/data/models/company.model';
import { seoState } from '@app/@core/store/reducers/seo.reducers';
import { Header } from '@app/@core/data/models/header.model';

@Component({
  selector: 'mti-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy {

  private currentTheme;
  private company$: Observable<Company>;
  public header$: Observable<Header>;
  private subscriptions: Subscription;

  public isMobileView: boolean = false;
  public companyLogo: string;
  public companyName: string;
  
  constructor(
    private store: Store<{
      company: CompanyState;
      seo: seoState;
    }>,
    private menuService: NbMenuService,
    private themeService: NbThemeService,
    private translate: TranslateService,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    this.subscriptions = new Subscription();
    this.translate.setDefaultLang('en');
    this.checkScreenSize();
    this.companyLogo = '';
    this.companyName = ''
  }

  ngOnInit() {
    this.currentTheme = this.themeService.currentTheme;
    this.themeService.changeTheme(this.currentTheme);
    this.company$ = this.store.select(store => store.company.company);
    this.header$ = this.store.select(store => store.seo.header);
    this.subscriptions.add(this.handleRouteSubscription());
  }

  private handleRouteSubscription(): Subscription {
    return this.router.events.subscribe(() => {
        let currentRoute = this.route.root
        let params: { [key: string]: any } = {};
        while (currentRoute.children.length > 0) {
          currentRoute = currentRoute.children[0];
          params = { ...params, ...currentRoute.snapshot.params }; 
        }

        const companyName = params['company']
        if (companyName) {
          this.companyName = companyName;
          this.store.dispatch(loadCompany({ name: companyName }));
          this.subscriptions.add(this.handleCompanySubscription());
        }
        else{
          this.companyLogo = 'https://tms.travelibex.com/assets/images/TIB-logo-web.png';
        }
      });
  }

  private handleCompanySubscription(): Subscription{
    return this.company$.subscribe(company => {
      if(company && company.logoUrl)
        this.companyLogo = company.logoUrl 
      else 
        this.companyLogo = 'https://tms.travelibex.com/assets/images/TIB-logo-web.png';
    });
  }

  checkScreenSize() {
    this.isMobileView = window.innerWidth < 768;
  }

  changeTheme(themeName: boolean) {
    this.currentTheme = themeName ? 'default' : 'dark';
    this.themeService.changeTheme(this.currentTheme);
  }

  navigateHome() {
    this.menuService.navigateHome();
    return false;
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
